import { render, staticRenderFns } from "./EditTab.vue?vue&type=template&id=733839f4"
import script from "./EditTab.vue?vue&type=script&lang=js"
export * from "./EditTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports